import React from 'react';

export const AFTIcon = () => {
  return (
    <div style={{ width: 300, height: 89 }}>
      <img style={{ width: 300, height: 89 }} src="/pictures/AFTIcon.png" alt="" />
    </div>
  );
};
